module.exports = __webpack_public_path__ + "img/envonriment.416ff325.png";